import { useQuery } from 'react-query';
import { useEffect } from 'react';

import { getTotalTrapsCaptureChart } from 'api/analitics/MCTCharts/5_getTotalTrapsCaptureChart';

export const useGetTotalTrapsCaptureChartData = (
  slug: string,
  period: string,
  start_date: string,
  end_date: string,
  enabled?: boolean,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['totalTrapsCaptureChartData', slug, start_date, end_date],
    () => getTotalTrapsCaptureChart(slug, period, start_date, end_date),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  useEffect(() => {
    refetch();
  }, [slug, refetch]);

  return { data, refetch, isLoading, isFetching };
};

export default useGetTotalTrapsCaptureChartData;
